var m = require('mithril');
var key = require('../../libs/keybindings');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var columnModalView = require('./columnModalView');
var columnValidation = require('./datasetColumnModalValidation');


function editColumnOnDataset(column, colIdx, datasetRecord, findedColumn, ctrl) {
  var modalState = {
    errors: []
  };
  var workingColumn = Object.assign({}, column);

  var submit = function() {
    modalState.errors = columnValidation.validateColumnName(workingColumn, datasetRecord.columns, colIdx);
    if (modalState.errors.length) {
      m.redraw();
      return Promise.resolve(false);
    }
    columnValidation.applyNormalizedColumnName(workingColumn);
    datasetRecord.columns[colIdx] = workingColumn;    
    return loaders.requestWithLoader({
      loader: 'background',
      url: `api/v1/dataset/${datasetRecord['@rid'].slice(1)}`,
      method: 'PUT',
      body: {columns: datasetRecord.columns}
    })
    .then(function () {
      if (findedColumn) {
        return loaders.requestWithLoader({
          loader: 'background',
          url: `api/v1/column/${findedColumn['@rid'].slice(1)}`,
          method: 'PUT',
          body: {name: workingColumn.name, type: workingColumn.type, unit: workingColumn.unit}
        });
      } 
      return Promise.resolve();
    })
    .then(function () {
      key.unbind('enter');
      modal.vm.close();
      ctrl.dashboardCallback && ctrl.dashboardCallback();
      ctrl.parentReinitialize && ctrl.parentReinitialize();
    });
  }

  function performDelete () {
    datasetRecord.columns.splice(colIdx, 1);
    return loaders.requestWithLoader({
      loader: 'background',
      url: `api/v1/dataset/${datasetRecord['@rid'].slice(1)}`,
      method: 'PUT',
      body: {columns: datasetRecord.columns}
    })
    .then(function () {
      key.unbind('enter');
      modal.vm.close();
      ctrl.parentReinitialize();
    });
  }

  function renderEditModal () {
    key.unbind('enter');
    key.setScope('modal');
    key('enter', 'modal', submit);
    modal.vm.title('Edit Column');
    modal.vm.body = columnModalView.bind(null, workingColumn, modalState);
    modal.vm.buttons([
      {
        label: "Delete",
        class: "dib mr2 red ",
        func: showDeleteConfirmation
      },
      {
        label: "Submit",
        class: "dib ",
        func: submit
      } 
    ]);
  }

  function showDeleteConfirmation () {
    key.unbind('enter');
    var confirmDelete = function () {
      return performDelete();
    };
    key('enter', 'modal', confirmDelete);
    modal.vm.title('Delete ' + (column.name || 'Column') + '?');
    modal.vm.body = function () {
      return m('div', [
        m('p', 'Are you sure you want to delete this column?')
      ]);
    };
    modal.vm.buttons([
      {
        label: "Cancel",
        class: "dib mr2 ",
        func: function () {
          renderEditModal();
          modal.vm.open();
        }
      },
      {
        label: "Delete",
        class: "dib red ",
        func: confirmDelete
      }
    ]);
    modal.vm.open();
  }

  renderEditModal();

  modal.vm.open();
}

module.exports = editColumnOnDataset;
